<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "Register"
})
</script>

<template>
  <div>
    <div class="row">
      <div class="col-6">
        <v-text-field
            append-icon="mdi-pen"
            class="mt-0 pt-0 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="نام مجموعه"
            outlined
        />
      </div>
      <div class="col-6">
        <v-text-field
            append-icon="mdi-pen"
            class="mt-0 pt-0 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="نام مجموعه"
            outlined
        />
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <v-text-field
            append-icon="mdi-pen"
            class="mt-0 pt-0 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="نام مجموعه"
            outlined
        />
      </div>
      <div class="col-6">
        <v-text-field
            append-icon="mdi-pen"
            class="mt-0 pt-0 contentinfo"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="نام مجموعه"
            outlined
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>